import { render, staticRenderFns } from "./ProfileDashboard.vue?vue&type=template&id=651e1123&scoped=true"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProfileDashboard.vue?vue&type=style&index=0&id=651e1123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e1123",
  null
  
)

export default component.exports